export const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
};

export const isMobile = () => {
    return window.innerWidth < 1025 ? true : false
}